import { ReactElement } from 'react';
import { useDispatch } from 'react-redux';

import { AddIcon, RemoveIcon, MapButton, Box } from '@methanesat/ui-components';

import { decreaseEmissionsMapViewStateZoom, increaseEmissionsMapViewStateZoom } from '../../reducers';

export interface EmissionsPageZoomControlsProps {
    zoom: number;
    minZoom: number;
    maxZoom: number;
}

export const EmissionsPageZoomControls = ({ zoom, minZoom, maxZoom }: EmissionsPageZoomControlsProps): ReactElement => {
    const dispatch = useDispatch();

    const zoomIn = () => {
        dispatch(increaseEmissionsMapViewStateZoom(1));
    };

    const zoomOut = () => {
        dispatch(decreaseEmissionsMapViewStateZoom(1));
    };

    const disableZoomIn = zoom === Math.floor(maxZoom - 1);
    const disableZoomOut = zoom === Math.floor(minZoom);

    return (
        <Box
            display="flex"
            flexDirection="column"
            textAlign="center"
            sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }}
        >
            <Box marginBottom={1}>
                <MapButton
                    onClick={zoomIn}
                    size="small"
                    data-testid="zoom-in-button"
                    id="map-zoom-in-button"
                    disabled={disableZoomIn}
                >
                    <AddIcon />
                </MapButton>
            </Box>
            <Box>
                <MapButton
                    size="small"
                    onClick={zoomOut}
                    data-testid="zoom-out-button"
                    id="map-zoom-out-button"
                    disabled={disableZoomOut}
                >
                    <RemoveIcon />
                </MapButton>
            </Box>
        </Box>
    );
};
